import { Component, Host, h, Prop } from '@stencil/core';

/**
 * @component icon-button
 * @tag anchor-icon-button
 * @description A clickable button with an icon.
 * @example
 * ```html
 * <anchor-icon-button theme="default" buttonTitle="Home">
 *   <anchor-icon slot="icon" name="x"></anchor-icon>
 * </anchor-icon-button>
 * ```
 */
@Component({
  tag: 'anchor-icon-button',
  styleUrl: 'icon-button.scss',
  shadow: true,
})
export class IconButton {
  /**
   * The theme of the button. Can be "default" or "on".
   */
  @Prop({ reflect: true }) theme: 'default' | 'on-dark' = 'default';

  /**
   * The title text that appears on hover.
   */
  @Prop() buttonTitle: string;

  /**
   * aria-label attribute for the button - used for accessibility.
   */
  @Prop() ariaLabel: string;

  /**
   *  Set whether or not the icon button should be disabled
   */
  @Prop({ mutable: true, reflect: true }) disabled?: boolean = false;

  render() {
    return (
      <Host style={{
        pointerEvents: this.disabled ? 'none' : undefined
      }}>
        <button
          class={`anchor-c-icon-button ${this.theme}`}
          title={this.buttonTitle}
          disabled={this.disabled}
          aria-label={this.ariaLabel}
        >
          <slot name="icon" />
        </button>
      </Host>
    );
  }
}
